export type CuttingStep = {
    step: number,
    description: string,
    img: string
}



export var cuttingSteps = [
    {
        step: 1,
        description: "",
        img: "IMG_2701.jpeg"
    },
    {
        step: 2,
        description: "",
        img: "IMG_2702.jpeg"
    },
    {
        step: 3,
        description: "",
        img: "IMG_2703.jpeg"
    },
    {
        step: 4,
        description: "",
        img: "IMG_2705.jpeg"
    },
    {
        step: 5,
        description: "",
        img: "IMG_2706.jpeg"
    },
    {
        step: 6,
        description: "",
        img: "IMG_2708.jpeg"
    },
    {
        step: 7,
        description: "",
        img: "IMG_2710.jpeg"
    },
    {
        step: 8,
        description: "",
        img: "IMG_2711.jpeg"
    },
    {
        step: 9,
        description: "",
        img: "IMG_2712.jpeg"
    }
]